import { render, staticRenderFns } from "./histsalaire.vue?vue&type=template&id=0185130d&"
import script from "./histsalaire.vue?vue&type=script&lang=js&"
export * from "./histsalaire.vue?vue&type=script&lang=js&"
import style0 from "./histsalaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports